var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"col-sm-12 remove-left-pad remove-right-pad text-align-center\">\n<span class=\"alert alert-danger col-sm-12\">{{'common.no_data_found' | translate}}</span>\n</div>";
var id1="service_assignment_rules.all.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./client/app/components/tnt_control/component/service_assignment_rules/all/service_assignment_rules.all.html
// module id = 2862
// module chunks = 1